<template>
  <div class="region-tooltip">
    <img
      src="/images/bg/region-select-tooltip-bg.jpg"
      class="region-tooltip__bg">

    <div class="region-tooltip__body">
      <p class="region-tooltip__title">
        Choose your in-game region
      </p>

      <div class="region-tooltip__tabs">
        <button
          class="button  region-tooltip__tab transition--color-bg"
          :class="{ 'button-additional': activeRegion === RegionModel.EU.id }"
          @click="activeRegion = RegionModel.EU.id">
          <span>{{ RegionModel.EU.title }}</span>

          <img
            :src="`/images/flags/EU.png`"
            width="20"
            height="13"
            :alt="`${RegionModel.EU.title} flag`">
        </button>

        <button
          class="button region-tooltip__tab transition--color-bg"
          :class="{ 'button-additional': activeRegion === RegionModel.USA.id }"
          @click="activeRegion = RegionModel.USA.id">
          <span>{{ RegionModel.USA.title }}</span>

          <img
            :src="`/images/flags/US.png`"
            width="20"
            height="13"
            :alt="`${ RegionModel.USA.title } flag`">
        </button>
      </div>

      <button
        class="button button-main region-tooltip__save"
        type="button"
        @click="confirmRegion">
        Save
      </button>
    </div>

    <div
      class="shape-cross"
      @click="confirmRegion" />
  </div>
</template>

<script>
import RegionModel from 'Models/RegionModel';

export default {
  name: 'RegionTooltip',

  data() {
    return {
      RegionModel,
      activeRegion: RegionModel.EU.id,
    };
  },

  methods: {
    confirmRegion() {
      this.$store.commit('mutateActiveRegion', this.activeRegion);
      this.saveRegionAtClient();
      this.emitClose();
    },

    saveRegionAtClient() {
      this.$cookie.set(RegionModel.REGION_COOKIE, this.activeRegion, { expires: '5Y' });
      localStorage.setItem(RegionModel.REGION_COOKIE, this.activeRegion);
    },

    emitClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .region-tooltip {
    background-color: $color--basic-black;
    border-radius: 8px;
    width: 270px;
    box-shadow: 0px 5px 25px rgba($color--basic-blue, 0.55);
    z-index: 1;
  }

  .region-tooltip__bg {
    @include fill;

    mix-blend-mode: luminosity;
    opacity: 0.5;
    display: block;
    z-index: -1;
  }

  .region-tooltip__title {
    font-weight: 500;
    font-size: 13px;
    text-align: center;
  }

  .region-tooltip__body {
    display: grid;
    grid-gap: 12px;
    width: 100%;
    padding: 16px;
  }

  .region-tooltip__tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 6px;
    border: 2px solid $color--basic-blue;
    border-radius: 4px;
    grid-gap: 6px;
  }

  .region-tooltip__tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;

    &:not(.button-additional):hover {
      background-color: $color--basic-blue;
    }

    img {
      margin-left: 4px;
    }
  }

  .region-tooltip__save {
    padding: 12px;
  }

  .button {
    font-size: 13px;
  }

  .shape-cross {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 13px;
    height: 13px;
  }

  .bold {
    font-weight: 500;
  }

  .clickable {
    cursor: pointer;
  }
</style>
